import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path d="M0 0L0 16 8.7 16 14 10 14 0 0 0zM2 2L12 2 12 9 7 9 7 14 2 14 2 2zM10.45 11L9 12.64 9 11 10.45 11zM18 16L18 32 26.7 32 32 26 32 16 18 16zM20 18L30 18 30 25 25 25 25 30 20 30 20 18zM28.45 27L27 28.64 27 27 28.45 27z"/>
      <path className="euiIcon__fillSecondary" d="M5 18L3 18C3 24.0751322 7.92486775 29 14 29L16 29 16 27 14 27C9.02943725 27 5 22.9705627 5 18zM18 3L16 3 16 5 18 5C22.9705627 5 27 9.02943725 27 14L29 14C29 7.92486775 24.0751322 3 18 3z"/>
    </g>
  </svg>
)
